"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Table_1 = __importDefault(require("@material-ui/core/Table"));
var TableBody_1 = __importDefault(require("@material-ui/core/TableBody"));
var TableCell_1 = __importDefault(require("@material-ui/core/TableCell"));
var TableHead_1 = __importDefault(require("@material-ui/core/TableHead"));
var TableRow_1 = __importDefault(require("@material-ui/core/TableRow"));
var TablePagination_1 = __importDefault(require("@material-ui/core/TablePagination"));
var TablePaginationActions_1 = __importDefault(require("./TablePaginationActions"));
var InfoRounded_1 = __importDefault(require("@material-ui/icons/InfoRounded"));
require("./TransactionTable.css");
var TransactionTableLoading_1 = __importDefault(require("./TransactionTableLoading/TransactionTableLoading"));
var loadingStyle = {
    height: '10%',
    width: '10%',
};
var CustomTableBody = function (_a) {
    var rows = _a.rows, headers = _a.headers;
    if (!rows || rows.length === 0) {
        return (react_1.default.createElement(TableRow_1.default, null,
            react_1.default.createElement(TableCell_1.default, { colSpan: headers ? headers.length : 1, className: "no-records-row" },
                react_1.default.createElement("div", { className: "transaction-table no-records" },
                    react_1.default.createElement(InfoRounded_1.default, null),
                    react_1.default.createElement("div", { className: "info-text" }, "No records found for selected criteria")))));
    }
    else {
        return (react_1.default.createElement(react_1.Fragment, null, rows.map(function (d, i) { return (react_1.default.createElement(TableRow_1.default, { key: i, className: d.classes
                ? d.classes.reduce(function (acc, current) {
                    return current + ' ' + acc;
                }, '')
                : '' }, Object.keys(d.data).map(function (k, i) { return (react_1.default.createElement(TableCell_1.default, { key: i },
            react_1.default.createElement("span", { className: "table-row-header" }, headers ? headers[i] : null),
            react_1.default.createElement("span", null, d.data[k]))); }))); })));
    }
};
var TransactionTable = function (_a) {
    var headers = _a.headers, rows = _a.rows, loading = _a.loading, paginator = _a.paginator;
    if (loading) {
        return (react_1.default.createElement("div", { className: "transaction-table" },
            react_1.default.createElement(Table_1.default, null,
                react_1.default.createElement(TableHead_1.default, null,
                    react_1.default.createElement(TableRow_1.default, null, headers ? headers.map(function (h, i) { return react_1.default.createElement(TableCell_1.default, { key: i }, h); }) : null)),
                react_1.default.createElement(TableBody_1.default, null,
                    react_1.default.createElement(TransactionTableLoading_1.default, { headers: headers })))));
    }
    else {
        return (react_1.default.createElement("div", { className: "transaction-table" },
            react_1.default.createElement(Table_1.default, null,
                react_1.default.createElement(TableHead_1.default, null,
                    react_1.default.createElement(TableRow_1.default, null, headers ? headers.map(function (h, i) { return react_1.default.createElement(TableCell_1.default, { key: i }, h); }) : null)),
                react_1.default.createElement(TableBody_1.default, null,
                    react_1.default.createElement(CustomTableBody, { rows: rows, headers: headers }))),
            react_1.default.createElement("div", null, paginator && rows && rows.length !== 0 ? (react_1.default.createElement(TablePagination_1.default, { rowsPerPageOptions: [paginator.rowsPerPage], labelDisplayedRows: function (_a) {
                    var from = _a.from, to = _a.to, count = _a.count;
                    return '';
                }, component: "div", count: paginator.totalRows, rowsPerPage: paginator.rowsPerPage, page: paginator.totalPages === 1 ? 0 : paginator.currentPage, onChangePage: paginator.onChangePage, ActionsComponent: TablePaginationActions_1.default, classes: {
                    toolbar: 'toolbar',
                    spacer: 'spacer',
                } })) : null)));
    }
};
exports.default = TransactionTable;
